module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pl-8-7"
    }
  }), _vm._v("CROSSWALK")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bck"
  }, [_c('p', {
    staticClass: "side1"
  }, [_c('b', [_vm._v("Finished Block:")]), _vm._v(" 13˝ × 13˝")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_c('b', [_vm._v("2½ strips:")]), _vm._v(" 5 print")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_c('b', [_vm._v("Background fabric:")]), _vm._v(" 8 squares 5˝ × 5˝")]), _vm._v(" "), _c('p', {
    staticClass: "side2"
  }, [_vm._v("(Makes 2 blocks.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('i', [_vm._v("No traffic, no waiting at stop signs. Everything is a go as you put your best foot forward and begin sewing on these lovely blocks!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('i', [_vm._v("All seams are ¼˝.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Make a strip set by sewing the 2½ strips together. Press the seam allowances all in the same direction. "), _c('b', [_vm._v("1A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Trim the strips into 4˝ increments. You should get 10 from each strip set. (You’ll use 4 for each block.) "), _c('b', [_vm._v("1B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Cut each 5˝ background square from corner to corner once on the diagonal to make 16 triangles. "), _c('b', [_vm._v("2A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Fold a strip set and 2 background triangles in half, finger pressing a crease in place to mark each halfway point. Match up the crease in the triangle with the crease in the strip set and sew a background triangle to either side of the strip set. Repeat with strip sets and triangles to make 8 units. "), _c('b', [_vm._v("3A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Trim the block so it measures 7˝ × 7˝. "), _c('b', [_vm._v("3B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sew the 4 units together as shown to make 1 block. "), _c('b', [_vm._v("3C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/8_6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "pl-9-8"
    }
  }), _c('i', [_vm._v("Crosswalk Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("True Colors by Amy Butler for Free Spirit")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "src": "images/9_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bck"
  }, [_c('p', {
    staticClass: "side1a"
  }, [_c('b', [_vm._v("Finished Quilt:")]), _vm._v(" 67˝ X 80˝")])]), _vm._v(" "), _c('p', {
    staticClass: "cap_h"
  }, [_vm._v("MATERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("QUILT TOP: 1 roll of 2½˝ print strips")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("2 packages of 5˝ background squares")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("INSIDE BORDER: ½ yard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("OUTSIDE BORDER: 1½ yards")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("BINDING: ½ yard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("BACKING: 5 yards - vertical seam(s)")]), _vm._v(" "), _c('p', {
    staticClass: "cap_h"
  }, [_vm._v("CONSTRUCTION NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This quilt uses 20 blocks, cut using 8 strips sets. Inner borders are cut 2½˝ wide. Outer borders are cut 6˝ wide.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8150be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0006_chapter-title-1.vue
// module id = 66
// module chunks = 0